module.exports = __webpack_public_path__ + "static/img/pelvis2_1.0591b9cd.png";